import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { HowItWorks } from './components/HowItWorks';
import { TrustIndicators } from './components/TrustIndicators';
import { ProductShowcase } from './components/ProductShowcase';
import { Pricing } from './components/Pricing';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { TeamPage } from './pages/TeamPage';
export function App() {
  const [darkMode, setDarkMode] = useState(false);
  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };
  const HomePage = () => <div className={`min-h-screen w-full ${darkMode ? 'dark bg-gray-900 text-white' : 'bg-white text-gray-900'}`} data-id="element-0">
      <Navbar darkMode={darkMode} toggleDarkMode={toggleDarkMode} data-id="element-1" />
      <main className="w-full" data-id="element-2">
        <Hero data-id="element-3" />
        <HowItWorks data-id="element-4" />
        <TrustIndicators data-id="element-5" />
        <ProductShowcase data-id="element-6" />
        <Pricing data-id="element-7" />
        <Contact data-id="element-8" />
        <Footer data-id="element-9" />
      </main>
    </div>;
  return <BrowserRouter data-id="element-10">
      <Routes data-id="element-11">
        <Route path="/" element={<HomePage data-id="element-13" />} data-id="element-12" />
        <Route path="/team" element={<TeamPage darkMode={darkMode} toggleDarkMode={toggleDarkMode} data-id="element-15" />} data-id="element-14" />
      </Routes>
    </BrowserRouter>;
}